import {
  setDoc,
  query,
  doc,
  getDoc,
  getDocs,
  collection,
  where,
  updateDoc,
  arrayUnion,
  arrayRemove,
} from "firebase/firestore";
import { db } from "../firebase-confg";

//User creation on Firestore using mail, Google or Facebook
export async function createUserInDatabase(cred) {
  const userRef = doc(db, "users", cred.user.uid);
  const userDoc = await getDoc(userRef);
  //First, we check if the document exist
  if (userDoc.exists()) {
    // console.log("Document data:", userDoc.data())
  } else {
    //If it doesn't exist yet, we create the user in the database
    setDoc(userRef, {
      pseudo: cred.user.displayName,
      friends: [],
      email: cred.user.email,
      // photo: cred.user.photoURL,
      image: null,
    });
  }
}

//FIREBASE GET ONE USER INFO
export function getOneUserInfo(userUID) {
  const userRef = doc(db, "users", userUID);
  return new Promise((resolve, reject) => {
    getDoc(userRef)
      .then((userDoc) => {
        // console.log(userDoc);
        resolve(userDoc);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//FIREBASE GET GIFTLIST BY USER
export function getGiftListByUser(userUID) {
  const wishesRef = collection(db, "wishes");
  const q = query(wishesRef, where("userId", "==", userUID));
  return new Promise((resolve, reject) => {
    getDocs(q)
      .then((giftDocs) => {
        resolve(giftDocs);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//FIREBASE GET ALL USERS EXCEPT CURRENT USER
export async function getFriendsSearchResultInDatabase(userUID, search) {
  //Search for pseudo
  const query1 = await getDocs(
    query(collection(db, "users"), where("pseudo", "==", search))
  );
  //Search for email
  const query2 = await getDocs(
    query(collection(db, "users"), where("email", "==", search))
  );
  let usersArray = [];
  query1.forEach((doc) => {
    if (doc.id !== userUID) {
      usersArray.push(doc);
    }
  });
  query2.forEach((doc) => {
    if (doc.id !== userUID) {
      usersArray.push(doc);
    }
  });
  return usersArray;
}

//FIREBASE ADD FRIEND
export async function addNewFriend(userUID, friendId) {
  const userRef = doc(db, "users", userUID);
  await updateDoc(userRef, {
    friends: arrayUnion(friendId),
  });
}

//FIREBASE REMOVE FRIEND
export async function removeFriend(userUID, friendId) {
  const userRef = doc(db, "users", userUID);
  await updateDoc(userRef, {
    friends: arrayRemove(friendId),
  });
}

//FIREBASE GRANT GIFT
export async function reserveWish(userUID, wishId) {
  const wishRef = doc(db, "wishes", wishId);
  await updateDoc(wishRef, {
    granted: true,
    providerId: userUID,
  });
}

export async function cancelWishReservation(wishId) {
  const wishRef = doc(db, "wishes", wishId);
  await updateDoc(wishRef, {
    granted: false,
    providerId: "",
  });
}

//Fonction de tri par ordre alphabétique
export function sortAlphabetically(giftsList) {
  return giftsList.sort((a, b) => a.title.localeCompare(b.title));
}

//Fonction de tri par prix du moins cher au plus cher
export function sortCheapestFirst(giftsList) {
  return giftsList.sort((a, b) =>
    parseInt(a.price) >= parseInt(b.price) ? 1 : -1
  );
}

//Fonction de tri par prix du plus cher au moins cher
export function sortExpensiveFirst(giftsList) {
  return giftsList.sort((a, b) =>
    parseInt(a.price) >= parseInt(b.price) ? -1 : 1
  );
}
